(function($) {
	"use strict";
	
	function init() {
		$('.pill-filter__pill').on('keydown', onPillKey);

		$('.pill-filter__item[data-url] input').on('change', onPillFilterWithUrlChange);
	}

	function onPillKey({ currentTarget, which: key }) {
		if (key === 13) {
			let input = currentTarget.previousElementSibling;
			let type = input.type;
			if ((type === 'radio' && !input.checked) || type !== 'radio') {
				input.checked = !input.checked;
				$(input).trigger("change");
			}
		}
	}

	function onPillFilterWithUrlChange() {
		var input = $(this);
		var ctn = input.closest(".pill-filter__item");
		var url = ctn.attr("data-url");
		location.href = url;
	}
	
	$(init);
	
})(jQuery);